import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import { isCurrentUserSuperAdmin } from '../utils/userRoles';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { PaperCard } from '../components/PaperCard';
import Grid from '@material-ui/core/Grid';
import * as ROUTES from '../utils/routes';
import { Link } from 'react-router-dom';
import InfoIcon from '@material-ui/icons/Info';

const styles = (theme) => ({
    header: {
        color: theme.palette.primary.main,
        fontWeight: 'bold',
    },
    pageTitle: {
        fontWeight: 'bold',
        fontSize: '1.6em',
        marginBottom: theme.spacing(2),
    },
    img: {
        width: '100%',
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
});

const ExpansionPanelSummary = withStyles({
    root: {
        backgroundColor: 'rgba(0, 0, 0, .03)',
    },
})(MuiExpansionPanelSummary);

function getDeviceGroupForGuide(deviceGroups, currentUser) {
    let deviceGroup;

    if (Object.keys(deviceGroups).length > 0 && currentUser) {
        Object.keys(deviceGroups).forEach(function(key) {
            let group = deviceGroups[key];
            if (group.organizationRef && currentUser.organizationRef) {
                if (group.organizationRef.id === currentUser.organizationRef.id && !deviceGroup) {
                    deviceGroup = group;
                }
            }
        });
    }

    if (!deviceGroup) {
        return {
            name: '[ERROR - NO DEVICE GROUP PRESENT]',
            registrationCode: '[ERROR - NO DEVICE GROUP PRESENT]',
        };
    } else {
        return deviceGroup;
    }
}

export class dashboardPage extends Component {
    render() {
        const { classes } = this.props;

        const deviceGroupForGuide = getDeviceGroupForGuide(this.props.deviceGroups, this.props.curentUser);

        return (
            <div>
                <Grid container justify="space-between">
                    <Grid item xs={8}>
                        <Typography variant="h5" className={classes.pageTitle}>
                            Dashboard
                        </Typography>
                    </Grid>
                </Grid>

                <PaperCard>
                    <h3>Welcome to the Mighty MDM Beta!</h3>
                    <p>
                        This online dashboard is where you’ll manage your devices. From here you’ll be able to remotely
                        install/update apps, enable Kiosk Mode, use our Mighty Launcher and more. Let’s get started by registering
                        one of your devices!
                    </p>

                    <ExpansionPanel defaultExpanded expanded>
                        <ExpansionPanelSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography className={classes.heading}>Getting Started</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <div>
                                <p>
                                    Follow this Getting Started guide to learn the Mighty MDM core concepts. By the end of the
                                    guide you will know how to:
                                </p>
                                <ul>
                                    <li>Register new devices on the platform</li>
                                    <li>Remotely manage apps on your devices</li>
                                    <li>Set up Kiosk Mode on your devices</li>
                                </ul>
                                <p>Prerequisites:</p>
                                <ol>
                                    <li>You need a VR device to register on the Mighty MDM</li>
                                    <li>You need a computer (Windows or Mac) that you can connect your VR device to.</li>
                                    <li>Your computer and VR device must be connected to the internet.</li>
                                    <li>
                                        Your VR device must have Developer Mode enabled.{' '}
                                        <i>See your device’s instruction manual for enabling Developer Mode.</i>
                                    </li>
                                </ol>

                                <h3>Register A Device</h3>

                                <ol>
                                    <li>
                                        Download the Mighty MDM Device Setup Tool (
                                        <a href="/downloadMightyMDMDeviceSetupTool?os=mac">Mac</a>/
                                        <a href="/downloadMightyMDMDeviceSetupTool?os=win">Windows</a>
                                        ).
                                    </li>
                                    <li>Open the Mighty MDM Device Setup Tool</li>
                                    <li>Login using your Mighty MDM account credentials</li>
                                    <li>Connect your VR headset to your computer</li>
                                    <li>Enter your device's target Device Group and Name (or use the defaults)</li>
                                    <li>Click "Install"</li>
                                </ol>

                                <p>Your device is now set up with the Mighty MDM and registered with your account!</p>

                                <div>
                                    <img src="/deviceSetupTool.jpg" className={classes.img} style={{ maxWidth: '600px' }} />
                                </div>

                                <p>
                                    <i>
                                        Note: The Mighty MDM Device Setup Tool has a few convenience features that can greatly
                                        speed up the device provisioning process (like bulk processing, offline configuration
                                        loading, and adding WiFi networks without putting on the headset). Find more instructions
                                        in the "Mighty MDM Device Setup Tool - Extra Features" section at the bottom of this page.
                                    </i>
                                </p>

                                <h3>Installing Demo APKs</h3>

                                <p>
                                    When you registered your device, it was automatically placed in your device group: "
                                    {deviceGroupForGuide.name}". In order to install some APKs onto your device, we have to edit
                                    this device group.
                                </p>

                                <ol>
                                    <li>
                                        Go to the <Link to={ROUTES.DEVICES}>Devices</Link> page
                                    </li>
                                    <li>
                                        Click on the info icon <InfoIcon /> next to your device group: "{deviceGroupForGuide.name}
                                        "
                                    </li>
                                    <li>
                                        Under Approved Apps, add the "Mighty Launcher" and "Mighty Companion Demo" apps. (Choose
                                        the appropriate apps for your device type)
                                    </li>
                                    <li>Click "Save" (in the top right)</li>
                                </ol>

                                <p>Your device should now immediately begin installing these apps.</p>
                                <p>
                                    In a few minutes, check your device’s app library for these new apps.{' '}
                                    <i>Note: On Oculus devices, these apps will appear in the Unknown Sources section.</i>
                                </p>

                                <img src="/Dashboard_approvedApps.jpg" className={classes.img} style={{ maxWidth: '600px' }} />

                                <h3>Setting up Kiosk Mode</h3>

                                <p>
                                    Kiosk Mode allows you to lock your VR device to a single app, turning your VR headset into a
                                    focused, single-purpose tool. Let’s demo this using the Mighty Launcher.
                                </p>

                                <p>
                                    In order to set up Kiosk Mode, we have to edit your device group: "{deviceGroupForGuide.name}
                                    ".
                                </p>

                                <ol>
                                    <li>
                                        Go to the <Link to={ROUTES.DEVICES}>Devices</Link> page
                                    </li>
                                    <li>
                                        Click on the info icon <InfoIcon /> next to your device group: "{deviceGroupForGuide.name}
                                        "
                                    </li>
                                    <li>
                                        Set Kiosk App to "Mighty Launcher." (Make sure you approved the app first, as instructed
                                        earlier in this guide)
                                    </li>
                                    <li>Click "Save" (in the top right)</li>
                                </ol>

                                <p>
                                    Now try it out on your VR device. Put on your headset and try to go to the default VR home
                                    screen. You should be redirected to the Mighty Launcher. Anytime you try to go home, you’ll be
                                    brought back to the Mighty Launcher.
                                </p>

                                <p>
                                    To turn off Kiosk Mode, just set the Device Group’s Kiosk App back to "<i>None</i>".
                                </p>

                                <img src="/Dashboard_kiosk.jpg" className={classes.img} style={{ maxWidth: '600px' }} />

                                <h4>About the Mighty Launcher</h4>
                                <p>
                                    The Mighty Launcher is our demo custom launcher, which you can use to replace the complex
                                    default VR app launchers. Any Approved Apps that are installed on the device will appear in
                                    the Mighty Launcher. You can customize some of the branding images in the Mighty Launcher on
                                    the <Link to={ROUTES.BRANDING}>Branding</Link> page.
                                </p>
                                <p>
                                    To edit the "Admin Settings" in the app, use PIN Code <b>5112</b>
                                </p>
                                <br />
                                <p>
                                    You’ve completed the Getting Started guide! Check out the sections below to learn more about
                                    the Mighty MDM.
                                </p>
                            </div>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>

                    <ExpansionPanel>
                        <ExpansionPanelSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2a-content"
                            id="panel2a-header"
                        >
                            <Typography className={classes.heading}>Mighty MDM Core Concepts</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <div>
                                <Typography>
                                    The Mighty MDM uses groups to facilitate easier management of many devices at once. Most
                                    settings and management features happen on the Device Group level.
                                </Typography>

                                <h4>Device Group</h4>
                                <p>
                                    <Link to={ROUTES.DEVICES}>Device Groups</Link> are how you manage devices. For the most part,
                                    you can’t directly manage a Device itself; instead, you manage its Device Group. This allows
                                    you to control many devices at once for large deployments. To edit a device’s Approved Apps
                                    and Kiosk App, you must edit the Device Group.
                                </p>
                                <h4>Devices</h4>
                                <p>
                                    <Link to={ROUTES.DEVICES}>Devices</Link> must be registered on the Mighty MDM using the
                                    Getting Started steps above. Once registered, you can track a device's status on the{' '}
                                    <Link to={ROUTES.DEVICES}>Devices</Link> page.
                                </p>
                                <h4>Apps</h4>

                                <p>There are two types of apps in the Dashboard:</p>
                                <ul>
                                    <li>
                                        <p>
                                            <Link to={ROUTES.MANAGED_APPS}>Managed Apps</Link> - Any custom app that your
                                            organization wants to make available to your devices. These apps are stored in the
                                            cloud and can be automatically installed, updated, and removed from a device over the
                                            internet. Once a device is given access to a managed app, it will install it as soon
                                            as it connected to the internet.
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <Link to={ROUTES.EXTERNAL_APPS}>External Apps</Link> - These apps are not directly
                                            managed by the Mighty MDM, and cannot be installed, updated, or uninstalled
                                            automatically. Approved External Apps that are installed on a device will appear in
                                            the Mighty Launcher, but installing the external app must be done manually. Often
                                            times an external app is a curated app from an App Store, or an app that you don’t
                                            want to manage using the Mighty MDM.
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>

                    <ExpansionPanel>
                        <ExpansionPanelSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel3a-content"
                            id="panel3a-header"
                        >
                            <Typography className={classes.heading}>Install/Manage Your Own APKs</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <div>
                                <Typography>To manage your own APK, start by creating a new Managed App:</Typography>
                                <ol>
                                    <li>
                                        Go to the <Link to={ROUTES.MANAGED_APPS}>Managed Apps</Link> page
                                    </li>
                                    <li>Click "+ New Managed App"</li>
                                    <li>Upload your APK</li>
                                    <li>
                                        Once the APK has uploaded, you’re done. You may change various details about the app if
                                        you wish.
                                    </li>
                                </ol>
                                <p>To install the app onto your device:</p>
                                <ol>
                                    <li>
                                        Edit the appropriate <Link to={ROUTES.DEVICES}>Device Group</Link>
                                    </li>
                                    <li>Add the new Managed App to the Device Group.</li>
                                </ol>
                            </div>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>

                    <ExpansionPanel>
                        <ExpansionPanelSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel4a-content"
                            id="panel4a-header"
                        >
                            <Typography className={classes.heading}>
                                Use External Apps for Kiosk Mode and the Mighty Launcher
                            </Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <div>
                                <Typography>
                                    You may have an app that you can’t manage through the Mighty MDM, but still want to be able to
                                    use it as a Kiosk App, or have it appear in the Mighty launcher. You can do this using
                                    External Apps.
                                </Typography>
                                <ol>
                                    <li>
                                        Go to the <Link to={ROUTES.EXTERNAL_APPS}>External Apps</Link> page
                                    </li>
                                    <li>Click "+ New External App"</li>
                                    <li>
                                        Input all required fields
                                        <ul>
                                            <li>
                                                <i>
                                                    Tip: If you're struggling to find the External App's Package Name, you may
                                                    find it listed in your Device's Installed Apps on the{' '}
                                                    <Link to={ROUTES.DEVICES}>Device</Link> page.
                                                </i>
                                            </li>
                                        </ul>
                                    </li>
                                    <li>Click "Save"</li>
                                </ol>
                                <p>
                                    To approve this app for your device to appear in the Mighty Launcher or be used as a Kiosk
                                    App:
                                </p>
                                <ol>
                                    <li>
                                        Edit the appropriate <Link to={ROUTES.DEVICES}>Device Group</Link>
                                    </li>
                                    <li>Add the new External App to the Device Group.</li>
                                </ol>

                                <p>
                                    <i>
                                        Remember: External apps are not directly managed by the Mighty MDM, and cannot be
                                        installed, updated, or uninstalled automatically.
                                    </i>
                                </p>
                            </div>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>

                    <ExpansionPanel>
                        <ExpansionPanelSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel6a-content"
                            id="panel6a-header"
                        >
                            <Typography className={classes.heading}>Mighty MDM Device Setup Tool - Extra Features</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <div>
                                <Typography>
                                    The Mighty MDM Device Setup Tool is used to provision devices with Mighty MDM. The tool will
                                    register your device with your account and install the necessary Mighty MDM software.
                                    (Download: <a href="/downloadMightyMDMDeviceSetupTool?os=mac">Mac</a>/
                                    <a href="/downloadMightyMDMDeviceSetupTool?os=win">Windows</a>). The tool features a few
                                    convenience features to improve the device provisioning process.
                                </Typography>
                                <br />
                                <Typography variant="h6">Bulk Device Setup</Typography>
                                <p>
                                    The Mighty MDM Device Setup Tool can be used with many devices at once. Plug in multiple
                                    devices to your computer at once and click the "Bulk Setup Options" button to see what
                                    features are avilable to you.
                                </p>
                                <div>
                                    <img src="/bulkSetupOptions.png" className={classes.img} style={{ maxWidth: '1000px' }} />
                                </div>
                                <Typography variant="h6">Add WiFi Network</Typography>
                                <p>
                                    Once you have installed the Mighty MDM, you'll be able to add a WiFi network to the device,
                                    saving you the time of putting on a headet manually entering WiFi credentials on each device.
                                </p>
                                <ol>
                                    <li>
                                        Click the More button next to your device{' '}
                                        <img src="/setupTool-3dot.png" style={{ maxWidth: 30 }} />
                                    </li>
                                    <li>Select "Add WiFi Network"</li>
                                    <li>Enter your network information and click "Submit"</li>
                                </ol>
                                <div>
                                    <img src="/setupTool-wifi.png" className={classes.img} style={{ maxWidth: '600px' }} />
                                </div>
                                <Typography variant="h6">Preload Device Configuration (Beta)</Typography>
                                <p>
                                    The Mighty MDM Device Setup Tool can fully provision a device with your MDM settings without
                                    your device ever needing access to the internet. With this feature enabled, the Setup Tool
                                    will download all apps and MDM configurations for a given device group, and sideload them
                                    directly onto the device at setup time. This can greatly speed up provisioning time and is
                                    particularly useful for setting up lots of devices at once because it reduces internet
                                    bandwidth requirements.
                                </p>
                                <p>To enable this feature:</p>
                                <ol>
                                    <li>Click the settings button in the top right.</li>
                                    <li>Turn on "Preload Device Configurations (Beta)"</li>
                                </ol>
                                <p>
                                    Now, the next time you run the "Install" process on a device, the Setup Tool will also preload
                                    the appropriate device configuration.
                                </p>

                                <div>
                                    <img
                                        src="/setupTool-preloadConfigurations.png"
                                        className={classes.img}
                                        style={{ maxWidth: '600px' }}
                                    />
                                </div>
                            </div>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>

                    <ExpansionPanel>
                        <ExpansionPanelSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel5a-content"
                            id="panel5a-header"
                        >
                            <Typography className={classes.heading}>Uninstall the Mighty MDM</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <div>
                                <Typography>
                                    The Mighty MDM Device Setup Tool will allow you to uninstall the Mighty MDM from your device.
                                    (Download: <a href="/downloadMightyMDMDeviceSetupTool?os=mac">Mac</a>/
                                    <a href="/downloadMightyMDMDeviceSetupTool?os=win">Windows</a>).
                                </Typography>
                                <p>
                                    <i>Note: The Oculus Quest 2 requires a factory reset to fully remove Mighty MDM.</i>
                                </p>
                            </div>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>

                    <ExpansionPanel>
                        <ExpansionPanelSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel7a-content"
                            id="panel7a-header"
                        >
                            <Typography className={classes.heading}>Mighty Launcher Admin PIN: 5112</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <div>
                                <Typography>
                                    In order to open the Admin Settings in the Mighty Launcher, you'll need to use Admin PIN 5112.
                                </Typography>
                            </div>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>

                    <ExpansionPanel>
                        <ExpansionPanelSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel7a-content"
                            id="panel7a-header"
                        >
                            <Typography className={classes.heading}>Disable Kiosk Mode For a Device</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <div>
                                <Typography>
                                    In some cases, you may need to disable Kiosk Mode for a single device. There are a few ways to
                                    do this:
                                    <ul>
                                        <li>
                                            If you have internet access, you can disable Kiosk Mode by sending the "Disable Kiosk
                                            Mode" command to a specific Device from the <Link to={ROUTES.DEVICES}>Devices</Link>{' '}
                                            page.
                                        </li>
                                        <li>
                                            If you are using the Mighty Launcher as your Kiosk App, you can disable Kiosk Mode
                                            directly in the app via the "Admin Settings" (Use PIN 5112 to access these settings).
                                        </li>
                                        <li>
                                            On Oculus devices, you can temporarily disable Kiosk Mode by pressing the Home button
                                            on your device's controller 5 times in quick succession. The next time you reopen the
                                            Kiosk App, Kiosk Mode will be re-enabled.
                                        </li>
                                        <li>
                                            Using the Mighty MDM Device Setup Tool, you can disable Kiosk Mode after plugging your
                                            device to your computer and using the "Disable Kiosk Mode" button (available in the
                                            extra actions menu).
                                        </li>
                                    </ul>
                                </Typography>
                            </div>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>

                    <ExpansionPanel>
                        <ExpansionPanelSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel6a-content"
                            id="panel6a-header"
                        >
                            <Typography className={classes.heading}>Troubleshooting</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <div>
                                <Typography>If you’re experiencing unexpected behavior, try the following steps:</Typography>
                                <ol>
                                    <li>Ensure your VR device is connected to the internet.</li>
                                    <li>Restart your VR device.</li>
                                </ol>

                                <p>If you’re still having trouble, please email us at support@mightyimmersion.com</p>
                                <p>If you’ve found a bug, please report it at bugs@mightyimmersion.com</p>
                            </div>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </PaperCard>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    organizations: state.data.organizations,
    curentUser: state.user.user,
    deviceGroups: state.data.deviceGroups,
});

const mapDispatchToProps = {};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(dashboardPage));
